import React, {useEffect, useRef, useState} from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../assets/main/groups/main-table/array.svg';
import {Link, NavLink} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "../../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {singUpMeeting} from "features/model/service/lessons/lessons-demo/sign-up-meeting/signUpMeeting";
import {singOffMeeting} from "features/model/service/lessons/lessons-demo/sing-off-meeting/singOffMeeting";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {setMeetingURL} from "features/model/slice/groups/botton-lesson/joinMeetingSlice";
import {joinMeeting} from "features/model/service/lessons/lessons-button/join-meeting/joinMeeting";
import {isIOS} from "react-device-detect";


export const LessonsItemDemo = () => {
    const dispatch = useAppDispatch();
    const LessonsData = useAppSelector((state) => state.lessonsDemo.items);
    const isLoading = useAppSelector((state) => state.lessonsDemo.isLoading);
    const responseSubscribedLessonId = useAppSelector((state) => state.lessonsDemo.subscribedLessonId);
    const [isLoadingMeeting, setIsLoadingMeeting] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isLoadingAction, setIsLoadingAction] = useState(false);
    const meetingURLData = useAppSelector(state => state.joinMeeting.meetingURL)
    const hiddenLinkRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        setIsSubscribed(responseSubscribedLessonId !== null);
    }, [responseSubscribedLessonId]);

    const joinSingUpMeeting = async (lessonsId: number) => {
        setIsLoadingMeeting(true);
        if (lessonsId) {
            await dispatch(singUpMeeting(lessonsId));
        }
        await dispatch(fetchLessonsDemo({}));
        setIsLoadingMeeting(false);
    };

    const singOffMeetingHandler = async (lessonsId: number) => {
        setIsLoadingMeeting(true);
        if (lessonsId) {
            await dispatch(singOffMeeting(lessonsId));
        }
        await dispatch(fetchLessonsDemo({}));
        setIsLoadingMeeting(false);
    };


    const joinMeetingHandler = async (lessonsId: string | undefined | number) => {
        if (lessonsId) {
            setIsLoadingAction(true)
            await dispatch(joinMeeting(lessonsId));
            dispatch(fetchLessonsDemo({}));
            setIsLoadingAction(false)
        }
    };

    useEffect(() => {
        if (meetingURLData) {
            if (isIOS) {
                window.location.href = meetingURLData;
            } else if (hiddenLinkRef.current) {
                hiddenLinkRef.current.href = meetingURLData;
                hiddenLinkRef.current.target = "_blank";
                hiddenLinkRef.current.rel = "noopener noreferrer";
                hiddenLinkRef.current.click();
            }
            dispatch(setMeetingURL(""));
        }
    }, [meetingURLData]);


    return (
        <>
            {isLoading ? (
                <Preloader/>
            ) : LessonsData.length > 0 ? (
                LessonsData.map((lesson) => {
                    const isSelectedLesson = lesson.id === responseSubscribedLessonId;
                    return (
                        <div className="row" key={lesson.id}>
                            <div className="col lesson-col full-width-mobile">
                                <span className="col-title">Занятие</span>
                                <p>
                                    <Link to={`/lessons/${lesson.id}`}>{lesson.title}</Link>
                                </p>
                            </div>

                            <div className="col status-col full-width-mobile">
                                <span className="col-title">Статус</span>
                                {lesson.status === 'new' ? (
                                    <p className="status-item">Новое</p>
                                ) : lesson.status === 'inProgress' ? (
                                    <p className="status-item in-progress">Занятие идёт</p>
                                ) : (
                                    <p className="status-item completed">Завершено</p>
                                )}
                            </div>
                            <div className="col lesson-time-col full-width-mobile">
                                <span className="col-title">Время занятия</span>
                                <time className="time">{lesson.startAt}</time>
                            </div>

                            <a
                                ref={hiddenLinkRef}
                                style={{display: 'none'}}
                                target="_self"
                                rel="noopener noreferrer"
                            >
                                Open Meeting
                            </a>

                            <div className="col btn-col full-width-mobile">
                                {isSelectedLesson && lesson.status === 'new' ? (
                                    <button
                                        onClick={() => singOffMeetingHandler(lesson.id)}
                                        className={`btn secondary${isLoadingMeeting ? ' disabled' : ''}`}
                                        disabled={isLoadingMeeting}
                                    >
                                        <span>{isLoadingMeeting ? 'Загрузка...' : 'Отменить'}</span>
                                    </button>
                                ) : (
                                    lesson.status === 'new' ? (
                                        <button
                                            onClick={() => joinSingUpMeeting(lesson.id)}
                                            className={`btn secondary${isLoadingMeeting ? ' disabled' : ''}`}
                                            disabled={isLoadingMeeting || isSubscribed}
                                        >
                                            <span>{isLoadingMeeting ? 'Загрузка...' : 'Записаться'}</span>
                                        </button>
                                    ) : (isSelectedLesson && lesson.status === 'inProgress' && (
                                        <button
                                            style={{width: '100%'}}
                                            className="btn"
                                            onClick={() => joinMeetingHandler(lesson.id)}
                                            disabled={isLoadingAction}
                                        >
                                            <a style={{boxShadow: 'none'}}>
                                                <span>{isLoadingAction ? 'Загрузка...' : 'Войти в занятие'}</span>
                                            </a>
                                        </button>
                                    )))
                                }
                            </div>


                            <div className="col btn-link-col">
                                <NavLink
                                    style={{borderBottom: 'none', textShadow: 'none'}}
                                    className="circle-arrow-btn"
                                    to={`/lessons/${lesson.id}`}
                                >
                                    <ArrayIcon/>
                                </NavLink>
                            </div>
                        </div>
                    );
                })
            ) : (
                <NothingYetMessage/>
            )}
        </>
    );
};


